import {
  LanguageTestSection,
  LanguageTestSectionInput
} from '../../lib/types/models/language-test/language-test-section'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createLanguageTestSection = ({
  templateId,
  ...data
}: LanguageTestSectionInput & { templateId: number }) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.createSection.url, { templateId }))
    .post<LanguageTestSection, LanguageTestSectionInput>(data)
